"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { Flag } from "lucide-react";
import { ReportEntityType } from "@/lib/report-categories";
import dynamic from "next/dynamic";

const ReportModal = dynamic(() => import("./report-modal").then((module) => module.ReportModal), { ssr: false });

interface ReportButtonProps {
  entityType: ReportEntityType;
  entityId: number;
  entityName: string;
}

export function ReportButton({
  entityType,
  entityId,
  entityName,
}: ReportButtonProps) {
  const t = useTranslations("Report");
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex cursor-pointer items-center gap-1 font-mono text-[10px] text-neutral-500 underline decoration-dashed decoration-neutral-600 underline-offset-2 transition-colors hover:text-neutral-300 hover:decoration-neutral-400"
      >
        <Flag className="h-3 w-3" />
        {t("reportIssue")}
      </button>
      {open && (
        <ReportModal
          entityType={entityType}
          entityId={entityId}
          entityName={entityName}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
